import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { Badge } from 'components/Badge';
import { Button } from 'components/Button';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { React } from 'libs/react';
import { getDealItemName } from 'helpers/Deal';
import { useTranslation } from 'components/translation/TranslationProvider';
import { FormInputPicker } from 'components/form/FormInputPicker';
import { SaleItemsWithRelationsListQuery } from 'graphql/SaleItem/queries/SaleItemsWithRelationsListQuery';
import { SaleItemPackageListQuery } from 'graphql/SaleItemPackage/queries/SaleItemPackageListQuery';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { DealModalDeleteConfirmation } from '../modal/DealModalDeleteConfirmation';
import { getAccountConfig } from 'components/account/AccountProvider';
import { useBreakpoint } from 'components/util/BreakpointProvider';
import { OPTION_LIST_CONFIGURATIONS } from 'helpers/optionConfiguration';
import './DealItemPanelGroupHeading.scss';
import { useSaleItemPickerFormat } from 'modules/catalog/saleItem/hooks/useSaleItemPickerFormat';
/**
 * @component DealItemPanelGroupHeading
 * @since 1.0.0
 */
export function DealItemPanelGroupHeading(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { style, item, type, configuration, editable, label, showIncludedOptions } = Object.assign({ style: 'normal', editable: true }, props);
    const breakpoint = useBreakpoint();
    const { updateItem, updateOptions, updatePackages, includeOption, includePackage, deal, configurationFields } = useDealConfiguratorContext();
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const { language } = useTranslation();
    const primarySaleItemInfo = getAccountConfig('PRIMARY_SALE_ITEM_INFO');
    const formatSaleItem = useSaleItemPickerFormat();
    /**
     * @function onManageItem
     * @since 1.0.0
     * @hidden
     */
    function onManageItem() {
        updateItem(item);
    }
    /**
     * @function onCloseModalDelete
     * @since 1.0.0
     * @hidden
     */
    const onCloseModalDelete = () => {
        setOpenModalDelete(false);
    };
    /**
     * @function onToggle
     * @since 1.0.0
     * @hidden
     */
    function onToggle() {
        if (props.onToggle) {
            props.onToggle();
        }
    }
    /**
     * @function onSelectOption
     * @since 1.0.0
     * @hidden
     */
    const onSelectOption = (selection) => {
        var _a, _b, _c, _d, _e, _f;
        const sourceItem = (_a = deal === null || deal === void 0 ? void 0 : deal.items.find((entry) => entry.id === item.id)) !== null && _a !== void 0 ? _a : item;
        const optionFromSaleItem = (_c = (_b = sourceItem.item) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.find((option) => { var _a; return ((_a = option.item) === null || _a === void 0 ? void 0 : _a.id) === selection.id; });
        const formatterSelections = {
            id: selection.id,
            item: selection,
            price: (_e = (_d = optionFromSaleItem === null || optionFromSaleItem === void 0 ? void 0 : optionFromSaleItem.price) !== null && _d !== void 0 ? _d : selection.price) !== null && _e !== void 0 ? _e : 0,
            priceDisplay: 'AMOUNT',
            hide: false,
            included: false,
            proposed: false,
            quantity: (_f = sourceItem.quantity) !== null && _f !== void 0 ? _f : 1,
            type: 'OPTION',
            createdAt: selection.createdAt,
            updatedAt: selection.updatedAt
        };
        includeOption(sourceItem, formatterSelections, true);
    };
    /**
     * @function onSelectPackage
     * @since 1.0.0
     * @hidden
     */
    const onSelectPackage = (selection) => {
        var _a, _b;
        const formatterSelections = {
            id: selection.id,
            package: selection,
            price: (_a = selection.price) !== null && _a !== void 0 ? _a : 0,
            priceDisplay: 'AMOUNT',
            hide: false,
            included: false,
            proposed: false,
            quantity: (_b = item.quantity) !== null && _b !== void 0 ? _b : 1,
            type: 'PACKAGE',
            createdAt: selection.createdAt,
            updatedAt: selection.updatedAt
        };
        includePackage(item, formatterSelections);
    };
    const className = classNames('deal-item-panel-group-heading', 'deal-item-panel-group-heading-' + style, props.className);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className },
            React.createElement(Case, { is: type == 'item' },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-toggler" },
                        React.createElement(Button, { style: "picto", picto: "chevron-up", onPress: onToggle })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement(Text, { value: getDealItemName(item, language, configurationFields) }))),
                React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" },
                    React.createElement(Case, { is: editable }, breakpoint.isBelowOrEqual('md') ? (React.createElement(Button, { style: "picto", picto: "gear", onPress: () => onManageItem(), className: "deal-item-panel-group-heading-button configure" })) : (React.createElement(Button, { label: t('Configure'), style: "primary", onPress: () => onManageItem(), className: "deal-item-panel-group-heading-button configure" })))),
                openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'item', item: item, configuration: configuration, onClose: onCloseModalDelete, deleteConfirmationMessage: `${t('Delete')} ${(_a = getDealItemName(item, language, configurationFields)) !== null && _a !== void 0 ? _a : ''}?` }))),
            React.createElement(Case, { is: type == 'package' },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-toggler" },
                        React.createElement(Button, { style: "picto", picto: ((_b = item.packages) === null || _b === void 0 ? void 0 : _b.length) ? 'chevron-up' : undefined, onPress: () => {
                                var _a;
                                ((_a = item.packages) === null || _a === void 0 ? void 0 : _a.length) && onToggle();
                            } })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement(Text, { value: t('Packages') })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" },
                        React.createElement(Badge, { label: (_d = (_c = item.packages) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0 }))),
                React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" }, editable && (React.createElement(React.Fragment, null,
                    React.createElement(FormInputPicker, { placeholder: t('Select'), query: SaleItemPackageListQuery, objectType: "saleItemPackages", queryOptions: {
                            saleItem: (_e = item.item) === null || _e === void 0 ? void 0 : _e.id
                        }, onSelect: (value) => {
                            onSelectPackage(value);
                        }, format: (value) => ({
                            id: value.id,
                            title: value.title,
                            infos: value.infos
                        }), clearable: true, size: "small", hasModalPicker: false }),
                    breakpoint.isBelowOrEqual('md') ? (React.createElement(Button, { style: "picto", className: "deal-item-panel-group-heading-button", picto: "plus", onPress: () => {
                            const itemWithAllPackages = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id);
                            updatePackages(itemWithAllPackages !== null && itemWithAllPackages !== void 0 ? itemWithAllPackages : item);
                        } })) : (React.createElement(Button, { label: t('Add Package'), style: "outline", className: "deal-item-panel-group-heading-button", onPress: () => {
                            const itemWithAllPackages = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id);
                            updatePackages(itemWithAllPackages !== null && itemWithAllPackages !== void 0 ? itemWithAllPackages : item);
                        } }))))),
                openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'package', item: item, configuration: configuration, onClose: onCloseModalDelete, deleteConfirmationMessage: `${t('Delete')} ${(_f = configuration === null || configuration === void 0 ? void 0 : configuration.package) === null || _f === void 0 ? void 0 : _f.title}?` }))),
            React.createElement(Case, { is: type == 'option' },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-toggler" },
                        React.createElement(Button, { style: "picto", picto: ((_g = item.options) === null || _g === void 0 ? void 0 : _g.length) ? 'chevron-up' : undefined, onPress: () => {
                                var _a;
                                ((_a = item.options) === null || _a === void 0 ? void 0 : _a.length) && onToggle();
                            } })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement(Text, { value: label !== null && label !== void 0 ? label : t('Options') })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" },
                        React.createElement(Badge, { label: (_j = (_h = item.options) === null || _h === void 0 ? void 0 : _h.filter((option) => !showIncludedOptions ? !option.included : true).length) !== null && _j !== void 0 ? _j : 0 }))),
                React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" }, editable && (React.createElement(React.Fragment, null,
                    React.createElement(FormInputPicker, { placeholder: t('Select'), query: SaleItemsWithRelationsListQuery, objectType: "saleItems", queryOptions: {
                            optionConfiguration: OPTION_LIST_CONFIGURATIONS,
                            saleItem: (_k = item.item) === null || _k === void 0 ? void 0 : _k.id,
                            saleItemVariant: (_l = item.variant) === null || _l === void 0 ? void 0 : _l.id,
                            active: true,
                            fromInternal: true,
                            order: primarySaleItemInfo == 'SKU' ? 'sku:asc' : 'title:asc'
                        }, onSelect: (value) => {
                            onSelectOption(value);
                        }, format: formatSaleItem, clearable: true, size: "small", hasModalPicker: false }),
                    breakpoint.isBelowOrEqual('md') ? (React.createElement(Button, { style: "picto", className: "deal-item-panel-group-heading-button", picto: "plus", onPress: () => {
                            const itemWithAllOptions = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id);
                            updateOptions(itemWithAllOptions !== null && itemWithAllOptions !== void 0 ? itemWithAllOptions : item, undefined, false);
                        } })) : (React.createElement(Button, { label: t('Add Option'), style: "outline", className: "deal-item-panel-group-heading-button", onPress: () => {
                            const itemWithAllOptions = deal === null || deal === void 0 ? void 0 : deal.items.find((i) => i.id === item.id);
                            updateOptions(itemWithAllOptions !== null && itemWithAllOptions !== void 0 ? itemWithAllOptions : item, undefined, false);
                        } }))))),
                openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'options', item: item, onClose: onCloseModalDelete, deleteConfirmationMessage: t('Delete all options?') }))),
            React.createElement(Case, { is: type == 'packageProposed' },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-toggler" },
                        React.createElement(Button, { style: "picto", picto: "chevron-up", onPress: onToggle })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement(Text, { value: t('Suggested Packages') })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" },
                        React.createElement(Badge, { label: (_o = (_m = item.packages) === null || _m === void 0 ? void 0 : _m.filter((pack) => pack.proposed).length) !== null && _o !== void 0 ? _o : 0 })))),
            React.createElement(Case, { is: type == 'optionProposed' },
                React.createElement("div", { className: "deal-item-panel-group-heading-title" },
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-toggler" },
                        React.createElement(Button, { style: "picto", picto: "chevron-up", onPress: onToggle })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-caption" },
                        React.createElement(Text, { value: label !== null && label !== void 0 ? label : t('Suggested Options') })),
                    React.createElement("div", { className: "deal-item-panel-group-heading-title-tooltip" },
                        React.createElement(Badge, { label: (_q = (_p = item.options) === null || _p === void 0 ? void 0 : _p.filter((option) => option.proposed).length) !== null && _q !== void 0 ? _q : 0 })))))));
}
